import React from "react";
import ReactDOM from "react-dom/client";
import "./style.css";   
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux"; 
import { Store } from "./NikeStore/ReduxToolKit/Store.js";  
import { Toaster } from "react-hot-toast";
const root = ReactDOM.createRoot(document.getElementById("root"));


root.render( 
            <BrowserRouter> 
                        <Provider store={Store}>
                              <Toaster position="top-center" reverseOrder={false}/> 
                                    <App /> 
                        </Provider>
            </BrowserRouter>
)
